module.exports = __webpack_public_path__ + "static/media/logo-patagonia-blanco.dfbf9284.svg";